import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { addUser, getAllRoles } from "../../services/ApiService";
import { Button, Form, Input, DatePicker, Select, message } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const AddUser = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [roles, setRoles] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await getAllRoles();
        if (res.responseCode === 200) {
          setRoles(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    fetchRoles();
  }, []);

  const handleSubmit = async (values) => {
    setSaving(true);
    try {
      const formData = new FormData();
      formData.append("organization", values.organization);
      formData.append("employee_id", values.employee_id);
      formData.append("email_id", values.email_id);
      formData.append("password", values.password);
      formData.append("employee_first_name", values.employee_first_name);
      formData.append("employee_middle_name", values.employee_middle_name || "");
      formData.append("employee_last_name", values.employee_last_name);
      formData.append("date_of_birth", values.date_of_birth.format("YYYY-MM-DD"));
      formData.append("employee_designation", values.employee_designation || "");
      formData.append("employee_phone", values.employee_phone || "");
      formData.append("role_id", values.role_id);

      const res = await addUser(formData);
      if (res.responseCode === 200) {
        message.success("User created successfully");
        navigate("/users");
      } else {
        message.error(res.responseMessage || "Failed to create user");
      }
    } catch (error) {
      console.error("Error creating user:", error);
      message.error("Failed to create user");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="main-box">
      <Sidebar activeId={12} />
      <main className="main-content">
        <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
          <Header title="Add User" />
          <div
            style={{
              flex: 1,
              padding: "1.5rem",
              boxSizing: "border-box",
              overflowY: "auto",
              maxWidth: 640,
            }}
          >
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Form.Item
                name="organization"
                label="Organization"
                rules={[{ required: true, message: "Organization is required" }]}
              >
                <Input className="input-box" />
              </Form.Item>

              <Form.Item
                name="employee_id"
                label="Employee ID"
                rules={[{ required: true, message: "Employee ID is required" }]}
              >
                <Input className="input-box" />
              </Form.Item>

              <Form.Item
                name="email_id"
                label="Email"
                rules={[
                  { required: true, message: "Email is required" },
                  { type: "email", message: "Enter a valid email" },
                ]}
              >
                <Input className="input-box" />
              </Form.Item>

              <Form.Item
                name="password"
                label="Password"
                rules={[{ required: true, message: "Password is required" }]}
              >
                <Input.Password className="input-box" />
              </Form.Item>

              <Form.Item
                name="employee_first_name"
                label="First Name"
                rules={[{ required: true, message: "First name is required" }]}
              >
                <Input className="input-box" />
              </Form.Item>

              <Form.Item name="employee_middle_name" label="Middle Name">
                <Input className="input-box" />
              </Form.Item>

              <Form.Item
                name="employee_last_name"
                label="Last Name"
                rules={[{ required: true, message: "Last name is required" }]}
              >
                <Input className="input-box" />
              </Form.Item>

              <Form.Item
                name="date_of_birth"
                label="Date of Birth"
                rules={[{ required: true, message: "Date of birth is required" }]}
              >
                <DatePicker
                  className="input-box"
                  style={{ width: "100%" }}
                  disabledDate={(d) => d && d.isAfter(dayjs())}
                />
              </Form.Item>

              <Form.Item name="employee_designation" label="Designation">
                <Input className="input-box" />
              </Form.Item>

              <Form.Item name="employee_phone" label="Phone">
                <Input className="input-box" />
              </Form.Item>

              <Form.Item
                name="role_id"
                label="Role"
                rules={[{ required: true, message: "Role is required" }]}
              >
                <Select
                  placeholder="Select a role"
                  options={roles.map((r) => ({ label: r.role_name, value: r.id }))}
                />
              </Form.Item>

              <div style={{ display: "flex", gap: "0.75rem" }}>
                <Button onClick={() => navigate("/users")}>Cancel</Button>
                <Button type="primary" htmlType="submit" loading={saving}>
                  Save User
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AddUser;
